// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdm-root {
  --pdm-surface: #ffffff;
  --pdm-page: #f4f6f9;
  --pdm-ink: #14181f;
  --pdm-ink-secondary: #5b6270;
  --pdm-ink-muted: #8b91a0;
  --pdm-border: rgba(11, 11, 11, 0.08);
  --pdm-grid-line: #e7e9ee;
  --pdm-blue: #2a78d6;
  --pdm-orange: #eb6834;
  --pdm-aqua: #1baf7a;
  --pdm-yellow: #eda100;
  --pdm-magenta: #e87ba4;
  --pdm-green: #008300;
  --pdm-violet: #4a3aa7;
  --pdm-red: #e34948;
  --pdm-good: #0ca30c;
  --pdm-warning: #ff6b6b;
  --pdm-serious: #ec835a;
  --pdm-critical: #d03b3b;
  --pdm-radius: 14px;
  --pdm-radius-sm: 10px;
  --pdm-shadow: 0 1px 2px rgba(20, 24, 31, 0.04), 0 6px 20px rgba(20, 24, 31, 0.06);
  background: var(--pdm-page);
  color: var(--pdm-ink);
  font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
  min-height: 100vh;
  padding: 20px 24px 48px;
  box-sizing: border-box;
}

.pdm-root * {
  box-sizing: border-box;
}

/* ---------- header ---------- */
.pdm-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}

.pdm-header-titles h1 {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
  letter-spacing: -0.01em;
}

.pdm-header-titles p {
  margin: 0;
  color: var(--pdm-ink-secondary);
  font-size: 13.5px;
}

.pdm-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.pdm-refresh-meta {
  font-size: 12px;
  color: var(--pdm-ink-muted);
}

.pdm-dashboard-tabs {
  display: flex;
  gap: 7px;
  flex-shrink: 0;
}

.pdm-dashboard-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.6px solid transparent;
  border-radius: 11px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  opacity: 0.62;
  transition: opacity 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

/* Custom tooltip (name on hover) instead of the native browser title
   tooltip - shows instantly with no delay and matches the app's look,
   since the tabs are icon-only with no visible label otherwise. */
.pdm-dashboard-tab::after {
  content: attr(data-tooltip);
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(-4px);
  background: #14181f;
  background: var(--pdm-ink, #14181f);
  color: #fff;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
  padding: 5px 9px;
  border-radius: 6px;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.12s ease, transform 0.12s ease;
  z-index: 30;
}

.pdm-dashboard-tab::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-bottom-color: #14181f;
  border-bottom-color: var(--pdm-ink, #14181f);
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.12s ease;
  z-index: 30;
}

.pdm-dashboard-tab:hover::after,
.pdm-dashboard-tab:hover::before {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.pdm-dashboard-tab svg {
  width: 23px;
  height: 23px;
  display: block;
}

.pdm-dashboard-tab:hover {
  opacity: 1;
  transform: translateY(-1px);
}

.pdm-dashboard-tab-active {
  opacity: 1;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.14);
}

/* Icons are flat, multi-color SVGs (not currentColor), so each tab gets its
   own pastel tile background instead - the rail should read at a glance
   like a small icon dock, even with no text labels. Active tab gets a
   matching-color border ring on top of the lift/shadow above. */
.pdm-tab-performance { background: #eaf2ff; }
.pdm-tab-performance.pdm-dashboard-tab-active { border-color: #2a78d6; }

.pdm-tab-transporter { background: #fff1e8; }
.pdm-tab-transporter.pdm-dashboard-tab-active { border-color: #eb6834; }

.pdm-tab-ftl { background: #e8f9f1; }
.pdm-tab-ftl.pdm-dashboard-tab-active { border-color: #0f9d68; }

.pdm-tab-inbound { background: #f1eefb; }
.pdm-tab-inbound.pdm-dashboard-tab-active { border-color: #4a3aa7; }

.pdm-tab-pod { background: #fdeef4; }
.pdm-tab-pod.pdm-dashboard-tab-active { border-color: #e87ba4; }

.pdm-tab-co2 { background: #eafaf0; }
.pdm-tab-co2.pdm-dashboard-tab-active { border-color: #0f9d68; }

.pdm-btn {
  border: 1px solid var(--pdm-border);
  background: var(--pdm-surface);
  color: var(--pdm-ink);
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: box-shadow .15s ease, transform .05s ease;
}

.pdm-btn:hover {
  box-shadow: var(--pdm-shadow);
}

.pdm-btn:active {
  transform: translateY(1px);
}

.pdm-btn-primary {
  background: var(--pdm-blue);
  border-color: var(--pdm-blue);
  color: #fff;
}

.pdm-btn-ghost {
  background: transparent;
}

.pdm-btn-sm {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 8px;
}

/* ---------- filter bar ---------- */
.pdm-filterbar {
  background: var(--pdm-surface);
  border: 1px solid var(--pdm-border);
  border-radius: var(--pdm-radius);
  box-shadow: var(--pdm-shadow);
  padding: 14px 16px;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.pdm-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 150px;
}

.pdm-field label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--pdm-ink-muted);
}

.pdm-field-grow {
  flex: 1 1 220px;
}

.pdm-datepicker {
  width: 100%;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--pdm-border);
  padding: 0 10px;
  font-size: 13px;
}

/* ---------- section ---------- */
.pdm-section {
  margin-bottom: 26px;
}

.pdm-section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.pdm-section-head h2 {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}

.pdm-section-head p {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--pdm-ink-secondary);
}

/* ---------- KPI cards ---------- */
.pdm-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  grid-gap: 14px;
  gap: 14px;
  margin-bottom: 22px;
}

.pdm-kpi-card {
  background: var(--pdm-surface);
  border: 1px solid var(--pdm-border);
  border-radius: var(--pdm-radius);
  box-shadow: var(--pdm-shadow);
  padding: 16px 18px;
  position: relative;
  overflow: hidden;
}

.pdm-kpi-card-clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.pdm-kpi-card-clickable:hover {
  border-color: var(--pdm-blue);
}

.pdm-kpi-card-active {
  border-color: var(--pdm-blue);
  box-shadow: 0 0 0 1px var(--pdm-blue) inset;
}

.pdm-kpi-label {
  font-size: 12px;
  color: var(--pdm-ink-secondary);
  font-weight: 600;
  margin-bottom: 8px;
}

.pdm-kpi-value {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.01em;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.pdm-kpi-sub {
  font-size: 12px;
  color: var(--pdm-ink-muted);
  margin-top: 4px;
}

.pdm-kpi-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.pdm-status-good { color: var(--pdm-good); }
.pdm-status-warning { color: var(--pdm-warning); }
.pdm-status-critical { color: var(--pdm-critical); }
.pdm-status-muted { color: var(--pdm-ink-muted); }
.pdm-bg-status-good { background: var(--pdm-good); }
.pdm-bg-status-warning { background: var(--pdm-warning); }
.pdm-bg-status-critical { background: var(--pdm-critical); }

/* ---------- generic card / grid layout ---------- */
.pdm-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: stretch;
  grid-gap: 14px;
  gap: 14px;
}

.pdm-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: stretch;
  grid-gap: 14px;
  gap: 14px;
}

@media (max-width: 1100px) {
  .pdm-grid-3 { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 720px) {
  .pdm-grid-2, .pdm-grid-3 { grid-template-columns: 1fr; }
}

/* Every direct grid item (a .pdm-card, or a GridCard's own root, which also
   carries .pdm-card) stretches to the row's tallest sibling by default -
   these rules make each card's own box fill that stretched height and let
   its main content area (a chart or the AG Grid) grow into the extra space,
   instead of leaving a shorter card with dead space at the bottom while a
   taller sibling looks fine (or a taller card just clipping its content). */
.pdm-card {
  background: var(--pdm-surface);
  border: 1px solid var(--pdm-border);
  border-radius: var(--pdm-radius);
  box-shadow: var(--pdm-shadow);
  padding: 16px;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.pdm-chart-flex {
  width: 100%;
}

/* When a chart has too many categories to fit the card width, its inner
   wrapper gets an explicit min-width (see chartScrollWidth()) wider than the
   card - this clips/scrolls that overflow horizontally instead of letting it
   stretch the card or squeeze every bar unreadably thin. The card's own size
   never changes; only the chart content scrolls inside it. */
.pdm-chart-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.pdm-chart-scroll::-webkit-scrollbar {
  height: 8px;
}

.pdm-chart-scroll::-webkit-scrollbar-thumb {
  background: var(--pdm-border);
  border-radius: 999px;
}

.pdm-card-title {
  font-size: 13.5px;
  font-weight: 700;
  margin: 0 0 2px;
}

.pdm-card-subtitle {
  font-size: 12px;
  color: var(--pdm-ink-secondary);
  margin: 0 0 10px;
}

.pdm-card-toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.pdm-chip {
  border: 1px solid var(--pdm-border);
  background: var(--pdm-page);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: var(--pdm-ink-secondary);
}

.pdm-chip-active {
  background: var(--pdm-blue);
  border-color: var(--pdm-blue);
  color: #fff;
}

.pdm-compare-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--pdm-page);
  border: 1px solid var(--pdm-border);
  border-radius: 999px;
  padding: 3px 6px 3px 10px;
  font-size: 12px;
}

.pdm-compare-tag button {
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--pdm-ink-muted);
  font-size: 13px;
  line-height: 1;
  padding: 2px;
}

.pdm-select-inline {
  min-width: 220px;
}

/* ---------- tables ---------- */
.pdm-table-wrap {
  overflow-x: auto;
}

.pdm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}

.pdm-table th {
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--pdm-ink-muted);
  border-bottom: 1px solid var(--pdm-grid-line);
  padding: 8px 10px;
  white-space: nowrap;
}

.pdm-table td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--pdm-grid-line);
  white-space: nowrap;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.pdm-table tbody tr:hover {
  background: var(--pdm-page);
}

.pdm-aggrid-shell {
  width: 100%;
}

/* ---------- loading / empty states ---------- */
.pdm-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(244, 246, 249, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.pdm-spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid var(--pdm-border);
  border-top-color: var(--pdm-blue);
  animation: pdm-spin 0.8s linear infinite;
}

@keyframes pdm-spin {
  to { transform: rotate(360deg); }
}

.pdm-skeleton {
  border-radius: var(--pdm-radius);
  background: linear-gradient(90deg, #eef0f4 25%, #f7f8fa 37%, #eef0f4 63%);
  background-size: 400% 100%;
  animation: pdm-shimmer 1.4s ease infinite;
}

@keyframes pdm-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.pdm-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 36px 16px;
  color: var(--pdm-ink-muted);
  gap: 6px;
}

.pdm-empty-state-icon {
  font-size: 26px;
  opacity: 0.6;
}

.pdm-empty-state strong {
  color: var(--pdm-ink-secondary);
  font-size: 13.5px;
}

.pdm-empty-state span {
  font-size: 12px;
  max-width: 320px;
}

.pdm-error-banner {
  background: #fdecea;
  border: 1px solid rgba(208, 59, 59, 0.25);
  color: #7a1f1f;
  border-radius: var(--pdm-radius-sm);
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 16px;
}

.pdm-notice-banner {
  background: #fff6e5;
  border: 1px solid rgba(250, 178, 25, 0.35);
  color: #9a6b00;
  border-radius: var(--pdm-radius-sm);
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 16px;
}

.pdm-quickfilter {
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--pdm-border);
  padding: 0 10px;
  font-size: 13px;
  min-width: 220px;
}

/* ---------- filter toolbar (Apply / Reset / Clear) ---------- */
.pdm-filter-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.pdm-filter-required::after {
  content: " *";
  color: var(--pdm-critical);
}

/* ---------- gauge KPI (vertical) ---------- */
.pdm-gauge-value {
  font-size: 34px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.pdm-gauge-vwrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 6px 0 4px;
}

.pdm-gauge-vtrack {
  position: relative;
  width: 72px;
  height: 240px;
  border-radius: 14px;
  background: var(--pdm-grid-line);
  overflow: hidden;
}

.pdm-gauge-vfill {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0 0 14px 14px;
  transition: height 0.4s ease;
}

.pdm-gauge-vtarget {
  position: absolute;
  left: -4px;
  right: -4px;
  height: 2px;
  background: var(--pdm-ink-muted);
  z-index: 1;
}

.pdm-gauge-vscale {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 240px;
  font-size: 11px;
  color: var(--pdm-ink-muted);
  text-align: center;
}

/* ---------- pending / not-yet-available widgets ---------- */
.pdm-pending-card {
  border: 1.5px dashed var(--pdm-border);
  background: repeating-linear-gradient(135deg, rgba(139,145,160,0.04), rgba(139,145,160,0.04) 10px, transparent 10px, transparent 20px);
}

.pdm-pending-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #fff6e5;
  color: #9a6b00;
  border: 1px solid rgba(250, 178, 25, 0.35);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* ---------- pivot / total rows ---------- */
.pdm-table td.pdm-sticky-col,
.pdm-table th.pdm-sticky-col {
  position: sticky;
  left: 0;
  background: var(--pdm-surface);
  z-index: 1;
  font-weight: 600;
}

.pdm-table tbody tr:hover td.pdm-sticky-col {
  background: var(--pdm-page);
}

.pdm-table tr.pdm-total-row td {
  font-weight: 700;
  background: var(--pdm-page);
  border-top: 2px solid var(--pdm-grid-line);
}

.pdm-table tr.pdm-total-row td.pdm-sticky-col {
  background: var(--pdm-page);
}

.pdm-helper-text {
  font-size: 11.5px;
  color: var(--pdm-ink-muted);
  margin-top: 6px;
}

.pdm-mode-toggle {
  display: flex;
  gap: 6px;
}

/* ---------- AG Grid report cards ---------- */
.pdm-grid-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pdm-grid-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.pdm-grid-card-titles {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.pdm-grid-record-count {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--pdm-ink-muted);
  background: var(--pdm-page);
  border-radius: 999px;
  padding: 2px 10px;
}

.pdm-grid-card-toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.pdm-icon-btn {
  border: 1px solid var(--pdm-border);
  background: var(--pdm-surface);
  color: var(--pdm-ink-secondary);
  border-radius: 8px;
  height: 32px;
  min-width: 32px;
  padding: 0 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.pdm-icon-btn:hover {
  box-shadow: var(--pdm-shadow);
  color: var(--pdm-ink);
}

.pdm-page-size-select {
  height: 32px;
  border-radius: 8px;
  border: 1px solid var(--pdm-border);
  padding: 0 8px;
  font-size: 12.5px;
  background: var(--pdm-surface);
  color: var(--pdm-ink-secondary);
}

.pdm-grid-fullscreen {
  position: fixed;
  inset: 12px;
  height: auto;
  z-index: 1000;
  box-shadow: 0 20px 60px rgba(11, 11, 11, 0.35);
  overflow: auto;
}

.pdm-ag-strong {
  font-weight: 700;
}

.pdm-ag-overlay {
  font-size: 13px;
  color: var(--pdm-ink-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/performanceDashboardModern.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iFAAiF;EACjF,2BAA2B;EAC3B,qBAAqB;EACrB,6DAA6D;EAC7D,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,2EAA2E;AAC7E;;AAEA;;kEAEkE;AAClE;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,4CAA4C;EAC5C,mBAAmC;EAAnC,mCAAmC;EACnC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4C;EAA5C,4CAA4C;EAC5C,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;gEAGgE;AAChE,uBAAuB,mBAAmB,EAAE;AAC5C,gDAAgD,qBAAqB,EAAE;;AAEvE,uBAAuB,mBAAmB,EAAE;AAC5C,gDAAgD,qBAAqB,EAAE;;AAEvE,eAAe,mBAAmB,EAAE;AACpC,wCAAwC,qBAAqB,EAAE;;AAE/D,mBAAmB,mBAAmB,EAAE;AACxC,4CAA4C,qBAAqB,EAAE;;AAEnE,eAAe,mBAAmB,EAAE;AACpC,wCAAwC,qBAAqB,EAAE;;AAE/D,eAAe,mBAAmB,EAAE;AACpC,wCAAwC,qBAAqB,EAAE;;AAE/D;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB,sBAAsB,EAAE;AAC3C,sBAAsB,yBAAyB,EAAE;AACjD,uBAAuB,0BAA0B,EAAE;AACnD,oBAAoB,2BAA2B,EAAE;AACjD,sBAAsB,2BAA2B,EAAE;AACnD,yBAAyB,8BAA8B,EAAE;AACzD,0BAA0B,+BAA+B,EAAE;;AAE3D,qDAAqD;AACrD;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,cAAc,qCAAqC,EAAE;AACvD;;AAEA;EACE,2BAA2B,0BAA0B,EAAE;AACzD;;AAEA;;;;;4EAK4E;AAC5E;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;6DAI6D;AAC7D;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;EACnB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,gCAAgC;EAChC,yEAAyE;EACzE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,sCAAsC;EACtC,sIAAsI;AACxI;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;;EAEE,gBAAgB;EAChB,OAAO;EACP,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B","sourcesContent":[".pdm-root {\n  --pdm-surface: #ffffff;\n  --pdm-page: #f4f6f9;\n  --pdm-ink: #14181f;\n  --pdm-ink-secondary: #5b6270;\n  --pdm-ink-muted: #8b91a0;\n  --pdm-border: rgba(11, 11, 11, 0.08);\n  --pdm-grid-line: #e7e9ee;\n  --pdm-blue: #2a78d6;\n  --pdm-orange: #eb6834;\n  --pdm-aqua: #1baf7a;\n  --pdm-yellow: #eda100;\n  --pdm-magenta: #e87ba4;\n  --pdm-green: #008300;\n  --pdm-violet: #4a3aa7;\n  --pdm-red: #e34948;\n  --pdm-good: #0ca30c;\n  --pdm-warning: #ff6b6b;\n  --pdm-serious: #ec835a;\n  --pdm-critical: #d03b3b;\n  --pdm-radius: 14px;\n  --pdm-radius-sm: 10px;\n  --pdm-shadow: 0 1px 2px rgba(20, 24, 31, 0.04), 0 6px 20px rgba(20, 24, 31, 0.06);\n  background: var(--pdm-page);\n  color: var(--pdm-ink);\n  font-family: system-ui, -apple-system, \"Segoe UI\", sans-serif;\n  min-height: 100vh;\n  padding: 20px 24px 48px;\n  box-sizing: border-box;\n}\n\n.pdm-root * {\n  box-sizing: border-box;\n}\n\n/* ---------- header ---------- */\n.pdm-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.pdm-header-titles h1 {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 4px;\n  letter-spacing: -0.01em;\n}\n\n.pdm-header-titles p {\n  margin: 0;\n  color: var(--pdm-ink-secondary);\n  font-size: 13.5px;\n}\n\n.pdm-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.pdm-refresh-meta {\n  font-size: 12px;\n  color: var(--pdm-ink-muted);\n}\n\n.pdm-dashboard-tabs {\n  display: flex;\n  gap: 7px;\n  flex-shrink: 0;\n}\n\n.pdm-dashboard-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.6px solid transparent;\n  border-radius: 11px;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  opacity: 0.62;\n  transition: opacity 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n/* Custom tooltip (name on hover) instead of the native browser title\n   tooltip - shows instantly with no delay and matches the app's look,\n   since the tabs are icon-only with no visible label otherwise. */\n.pdm-dashboard-tab::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%) translateY(-4px);\n  background: var(--pdm-ink, #14181f);\n  color: #fff;\n  font-size: 11.5px;\n  font-weight: 600;\n  white-space: nowrap;\n  padding: 5px 9px;\n  border-radius: 6px;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.12s ease, transform 0.12s ease;\n  z-index: 30;\n}\n\n.pdm-dashboard-tab::before {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-bottom-color: var(--pdm-ink, #14181f);\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.12s ease;\n  z-index: 30;\n}\n\n.pdm-dashboard-tab:hover::after,\n.pdm-dashboard-tab:hover::before {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(0);\n}\n\n.pdm-dashboard-tab svg {\n  width: 23px;\n  height: 23px;\n  display: block;\n}\n\n.pdm-dashboard-tab:hover {\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\n.pdm-dashboard-tab-active {\n  opacity: 1;\n  transform: translateY(-1px);\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.14);\n}\n\n/* Icons are flat, multi-color SVGs (not currentColor), so each tab gets its\n   own pastel tile background instead - the rail should read at a glance\n   like a small icon dock, even with no text labels. Active tab gets a\n   matching-color border ring on top of the lift/shadow above. */\n.pdm-tab-performance { background: #eaf2ff; }\n.pdm-tab-performance.pdm-dashboard-tab-active { border-color: #2a78d6; }\n\n.pdm-tab-transporter { background: #fff1e8; }\n.pdm-tab-transporter.pdm-dashboard-tab-active { border-color: #eb6834; }\n\n.pdm-tab-ftl { background: #e8f9f1; }\n.pdm-tab-ftl.pdm-dashboard-tab-active { border-color: #0f9d68; }\n\n.pdm-tab-inbound { background: #f1eefb; }\n.pdm-tab-inbound.pdm-dashboard-tab-active { border-color: #4a3aa7; }\n\n.pdm-tab-pod { background: #fdeef4; }\n.pdm-tab-pod.pdm-dashboard-tab-active { border-color: #e87ba4; }\n\n.pdm-tab-co2 { background: #eafaf0; }\n.pdm-tab-co2.pdm-dashboard-tab-active { border-color: #0f9d68; }\n\n.pdm-btn {\n  border: 1px solid var(--pdm-border);\n  background: var(--pdm-surface);\n  color: var(--pdm-ink);\n  border-radius: 10px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: box-shadow .15s ease, transform .05s ease;\n}\n\n.pdm-btn:hover {\n  box-shadow: var(--pdm-shadow);\n}\n\n.pdm-btn:active {\n  transform: translateY(1px);\n}\n\n.pdm-btn-primary {\n  background: var(--pdm-blue);\n  border-color: var(--pdm-blue);\n  color: #fff;\n}\n\n.pdm-btn-ghost {\n  background: transparent;\n}\n\n.pdm-btn-sm {\n  padding: 5px 10px;\n  font-size: 12px;\n  border-radius: 8px;\n}\n\n/* ---------- filter bar ---------- */\n.pdm-filterbar {\n  background: var(--pdm-surface);\n  border: 1px solid var(--pdm-border);\n  border-radius: var(--pdm-radius);\n  box-shadow: var(--pdm-shadow);\n  padding: 14px 16px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.pdm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 150px;\n}\n\n.pdm-field label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--pdm-ink-muted);\n}\n\n.pdm-field-grow {\n  flex: 1 1 220px;\n}\n\n.pdm-datepicker {\n  width: 100%;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid var(--pdm-border);\n  padding: 0 10px;\n  font-size: 13px;\n}\n\n/* ---------- section ---------- */\n.pdm-section {\n  margin-bottom: 26px;\n}\n\n.pdm-section-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.pdm-section-head h2 {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.pdm-section-head p {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: var(--pdm-ink-secondary);\n}\n\n/* ---------- KPI cards ---------- */\n.pdm-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 14px;\n  margin-bottom: 22px;\n}\n\n.pdm-kpi-card {\n  background: var(--pdm-surface);\n  border: 1px solid var(--pdm-border);\n  border-radius: var(--pdm-radius);\n  box-shadow: var(--pdm-shadow);\n  padding: 16px 18px;\n  position: relative;\n  overflow: hidden;\n}\n\n.pdm-kpi-card-clickable {\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pdm-kpi-card-clickable:hover {\n  border-color: var(--pdm-blue);\n}\n\n.pdm-kpi-card-active {\n  border-color: var(--pdm-blue);\n  box-shadow: 0 0 0 1px var(--pdm-blue) inset;\n}\n\n.pdm-kpi-label {\n  font-size: 12px;\n  color: var(--pdm-ink-secondary);\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.pdm-kpi-value {\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n}\n\n.pdm-kpi-sub {\n  font-size: 12px;\n  color: var(--pdm-ink-muted);\n  margin-top: 4px;\n}\n\n.pdm-kpi-badge {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.pdm-status-good { color: var(--pdm-good); }\n.pdm-status-warning { color: var(--pdm-warning); }\n.pdm-status-critical { color: var(--pdm-critical); }\n.pdm-status-muted { color: var(--pdm-ink-muted); }\n.pdm-bg-status-good { background: var(--pdm-good); }\n.pdm-bg-status-warning { background: var(--pdm-warning); }\n.pdm-bg-status-critical { background: var(--pdm-critical); }\n\n/* ---------- generic card / grid layout ---------- */\n.pdm-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  align-items: stretch;\n  gap: 14px;\n}\n\n.pdm-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  align-items: stretch;\n  gap: 14px;\n}\n\n@media (max-width: 1100px) {\n  .pdm-grid-3 { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 720px) {\n  .pdm-grid-2, .pdm-grid-3 { grid-template-columns: 1fr; }\n}\n\n/* Every direct grid item (a .pdm-card, or a GridCard's own root, which also\n   carries .pdm-card) stretches to the row's tallest sibling by default -\n   these rules make each card's own box fill that stretched height and let\n   its main content area (a chart or the AG Grid) grow into the extra space,\n   instead of leaving a shorter card with dead space at the bottom while a\n   taller sibling looks fine (or a taller card just clipping its content). */\n.pdm-card {\n  background: var(--pdm-surface);\n  border: 1px solid var(--pdm-border);\n  border-radius: var(--pdm-radius);\n  box-shadow: var(--pdm-shadow);\n  padding: 16px;\n  min-width: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.pdm-chart-flex {\n  width: 100%;\n}\n\n/* When a chart has too many categories to fit the card width, its inner\n   wrapper gets an explicit min-width (see chartScrollWidth()) wider than the\n   card - this clips/scrolls that overflow horizontally instead of letting it\n   stretch the card or squeeze every bar unreadably thin. The card's own size\n   never changes; only the chart content scrolls inside it. */\n.pdm-chart-scroll {\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.pdm-chart-scroll::-webkit-scrollbar {\n  height: 8px;\n}\n\n.pdm-chart-scroll::-webkit-scrollbar-thumb {\n  background: var(--pdm-border);\n  border-radius: 999px;\n}\n\n.pdm-card-title {\n  font-size: 13.5px;\n  font-weight: 700;\n  margin: 0 0 2px;\n}\n\n.pdm-card-subtitle {\n  font-size: 12px;\n  color: var(--pdm-ink-secondary);\n  margin: 0 0 10px;\n}\n\n.pdm-card-toolbar {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n\n.pdm-chip {\n  border: 1px solid var(--pdm-border);\n  background: var(--pdm-page);\n  border-radius: 999px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--pdm-ink-secondary);\n}\n\n.pdm-chip-active {\n  background: var(--pdm-blue);\n  border-color: var(--pdm-blue);\n  color: #fff;\n}\n\n.pdm-compare-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--pdm-page);\n  border: 1px solid var(--pdm-border);\n  border-radius: 999px;\n  padding: 3px 6px 3px 10px;\n  font-size: 12px;\n}\n\n.pdm-compare-tag button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--pdm-ink-muted);\n  font-size: 13px;\n  line-height: 1;\n  padding: 2px;\n}\n\n.pdm-select-inline {\n  min-width: 220px;\n}\n\n/* ---------- tables ---------- */\n.pdm-table-wrap {\n  overflow-x: auto;\n}\n\n.pdm-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n\n.pdm-table th {\n  text-align: left;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--pdm-ink-muted);\n  border-bottom: 1px solid var(--pdm-grid-line);\n  padding: 8px 10px;\n  white-space: nowrap;\n}\n\n.pdm-table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--pdm-grid-line);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.pdm-table tbody tr:hover {\n  background: var(--pdm-page);\n}\n\n.pdm-aggrid-shell {\n  width: 100%;\n}\n\n/* ---------- loading / empty states ---------- */\n.pdm-loading-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(244, 246, 249, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n}\n\n.pdm-spinner {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 3px solid var(--pdm-border);\n  border-top-color: var(--pdm-blue);\n  animation: pdm-spin 0.8s linear infinite;\n}\n\n@keyframes pdm-spin {\n  to { transform: rotate(360deg); }\n}\n\n.pdm-skeleton {\n  border-radius: var(--pdm-radius);\n  background: linear-gradient(90deg, #eef0f4 25%, #f7f8fa 37%, #eef0f4 63%);\n  background-size: 400% 100%;\n  animation: pdm-shimmer 1.4s ease infinite;\n}\n\n@keyframes pdm-shimmer {\n  0% { background-position: 100% 50%; }\n  100% { background-position: 0 50%; }\n}\n\n.pdm-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 36px 16px;\n  color: var(--pdm-ink-muted);\n  gap: 6px;\n}\n\n.pdm-empty-state-icon {\n  font-size: 26px;\n  opacity: 0.6;\n}\n\n.pdm-empty-state strong {\n  color: var(--pdm-ink-secondary);\n  font-size: 13.5px;\n}\n\n.pdm-empty-state span {\n  font-size: 12px;\n  max-width: 320px;\n}\n\n.pdm-error-banner {\n  background: #fdecea;\n  border: 1px solid rgba(208, 59, 59, 0.25);\n  color: #7a1f1f;\n  border-radius: var(--pdm-radius-sm);\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.pdm-notice-banner {\n  background: #fff6e5;\n  border: 1px solid rgba(250, 178, 25, 0.35);\n  color: #9a6b00;\n  border-radius: var(--pdm-radius-sm);\n  padding: 10px 14px;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.pdm-quickfilter {\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid var(--pdm-border);\n  padding: 0 10px;\n  font-size: 13px;\n  min-width: 220px;\n}\n\n/* ---------- filter toolbar (Apply / Reset / Clear) ---------- */\n.pdm-filter-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.pdm-filter-required::after {\n  content: \" *\";\n  color: var(--pdm-critical);\n}\n\n/* ---------- gauge KPI (vertical) ---------- */\n.pdm-gauge-value {\n  font-size: 34px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  font-variant-numeric: tabular-nums;\n}\n\n.pdm-gauge-vwrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 6px 0 4px;\n}\n\n.pdm-gauge-vtrack {\n  position: relative;\n  width: 72px;\n  height: 240px;\n  border-radius: 14px;\n  background: var(--pdm-grid-line);\n  overflow: hidden;\n}\n\n.pdm-gauge-vfill {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 0 0 14px 14px;\n  transition: height 0.4s ease;\n}\n\n.pdm-gauge-vtarget {\n  position: absolute;\n  left: -4px;\n  right: -4px;\n  height: 2px;\n  background: var(--pdm-ink-muted);\n  z-index: 1;\n}\n\n.pdm-gauge-vscale {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  height: 240px;\n  font-size: 11px;\n  color: var(--pdm-ink-muted);\n  text-align: center;\n}\n\n/* ---------- pending / not-yet-available widgets ---------- */\n.pdm-pending-card {\n  border: 1.5px dashed var(--pdm-border);\n  background: repeating-linear-gradient(135deg, rgba(139,145,160,0.04), rgba(139,145,160,0.04) 10px, transparent 10px, transparent 20px);\n}\n\n.pdm-pending-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: #fff6e5;\n  color: #9a6b00;\n  border: 1px solid rgba(250, 178, 25, 0.35);\n  border-radius: 999px;\n  padding: 2px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* ---------- pivot / total rows ---------- */\n.pdm-table td.pdm-sticky-col,\n.pdm-table th.pdm-sticky-col {\n  position: sticky;\n  left: 0;\n  background: var(--pdm-surface);\n  z-index: 1;\n  font-weight: 600;\n}\n\n.pdm-table tbody tr:hover td.pdm-sticky-col {\n  background: var(--pdm-page);\n}\n\n.pdm-table tr.pdm-total-row td {\n  font-weight: 700;\n  background: var(--pdm-page);\n  border-top: 2px solid var(--pdm-grid-line);\n}\n\n.pdm-table tr.pdm-total-row td.pdm-sticky-col {\n  background: var(--pdm-page);\n}\n\n.pdm-helper-text {\n  font-size: 11.5px;\n  color: var(--pdm-ink-muted);\n  margin-top: 6px;\n}\n\n.pdm-mode-toggle {\n  display: flex;\n  gap: 6px;\n}\n\n/* ---------- AG Grid report cards ---------- */\n.pdm-grid-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pdm-grid-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.pdm-grid-card-titles {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pdm-grid-record-count {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--pdm-ink-muted);\n  background: var(--pdm-page);\n  border-radius: 999px;\n  padding: 2px 10px;\n}\n\n.pdm-grid-card-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.pdm-icon-btn {\n  border: 1px solid var(--pdm-border);\n  background: var(--pdm-surface);\n  color: var(--pdm-ink-secondary);\n  border-radius: 8px;\n  height: 32px;\n  min-width: 32px;\n  padding: 0 8px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pdm-icon-btn:hover {\n  box-shadow: var(--pdm-shadow);\n  color: var(--pdm-ink);\n}\n\n.pdm-page-size-select {\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid var(--pdm-border);\n  padding: 0 8px;\n  font-size: 12.5px;\n  background: var(--pdm-surface);\n  color: var(--pdm-ink-secondary);\n}\n\n.pdm-grid-fullscreen {\n  position: fixed;\n  inset: 12px;\n  height: auto;\n  z-index: 1000;\n  box-shadow: 0 20px 60px rgba(11, 11, 11, 0.35);\n  overflow: auto;\n}\n\n.pdm-ag-strong {\n  font-weight: 700;\n}\n\n.pdm-ag-overlay {\n  font-size: 13px;\n  color: var(--pdm-ink-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
